<template>
  <v-card flat>
    <v-card-title>Bestenliste</v-card-title>
    <v-card-text>
      <v-data-table :headers="headers" :items="items" :items-per-page="25" :footer-props="{'items-per-page-options':[10,25,50,-1]}" dense>
        <template v-slot:item.action="{item}">
          <v-icon small @click="() => { del.item = item; del.open = true}">far fa-trash</v-icon>
        </template>
      </v-data-table>
    </v-card-text>

    <v-dialog v-model="del.open" @keydown.esc="del.open = false" persistent width="400">
      <v-card flat>
        <v-card-title><v-icon class="mr-5">far fa-trash</v-icon>Wirklich löschen?</v-card-title>
        <v-card-actions>
          <v-btn @click="() => {del.open = false; $store.commit('del', del.item.id)}" class="red lighten-2">Ja</v-btn>
          <div class="flex-grow-1" />
          <v-btn @click="del.open = false" class="green lighten-2">Abbrechen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import Vue from 'vue'

export default {
  name: "besttable",
  data: () => ({
    headers: [
      {
        text: 'Platz',
        value: 'platz',
        sortable: false,
        align: 'center',
        divider: true
      },
      {
        text: 'Name',
        value: 'name',
        sortable: false
      },
      /* {
        text: 'Verein',
        value: 'verein',
        sortable: false,
        divider: true
      }, */
      {
        text: 'Geschlecht',
        value: 'mwd',
        sortable: false,
        align: 'center',
        divider: true
      },
      {
        text: 'Zeit',
        value: 'timeformat',
        sortable: false,
        align: 'end',
        divider: true
      },
      {
        text: '',
        value: 'action',
        sortable: false,
        align: 'center'
      }
    ],
    del: {
      open: false,
      item: null
    }
  }),
  computed: {
    items () {
      return this.$store.state.ergebnisse
          .slice()
          .sort((a, b) => parseFloat(a.time) < parseFloat(b.time) ? -1 : 1)
          .map((e, i, arr) => {
            return {...e, time: Vue.filter('float2_0')(e.time) + ' s', timeformat: this.timeformat(e.time), platz: arr.filter(o => parseFloat(o.time) < parseFloat(e.time)).length + 1}
          })
    }
  },
  methods: {
    timeformat (val) {
      let min = Math.floor(val / 60)
      let sec = this.$options.filters.float2_0(val - 60 * min)
      if (sec < 10) sec = '0' + sec
      return `${min}:${sec}`
    }
  }
}
</script>

<style scoped>

</style>
